/* eslint-disable */
// src/utils/securityDisplay.js

export function formatDateTime(value) {
  if (!value) return "Sin dato";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin dato";
  return date.toLocaleString();
}

export function formatSecurityDateTime(value) {
  if (!value) return "Sin dato";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin dato";
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${hour}:${minute}`;
}

function detectPlatform(userAgent) {
  const ua = String(userAgent || "").toLowerCase();
  if (!ua) return "Dispositivo";
  if (ua.includes("android")) return "Android";
  if (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod")) return "iOS";
  if (ua.includes("windows")) return "Windows";
  if (ua.includes("mac os") || ua.includes("macintosh")) return "Mac";
  if (ua.includes("linux")) return "Linux";
  return "Dispositivo";
}

function detectBrowser(userAgent) {
  const ua = String(userAgent || "").toLowerCase();
  if (!ua) return "Navegador";
  if (ua.includes("edg/")) return "Edge";
  if (ua.includes("opr/") || ua.includes("opera")) return "Opera";
  if (ua.includes("firefox/")) return "Firefox";
  if (ua.includes("chrome/") || ua.includes("crios/")) return "Chrome";
  if (ua.includes("safari/")) return "Safari";
  return "Navegador";
}

export function getDeviceSummary(userAgent) {
  return `${detectPlatform(userAgent)} / ${detectBrowser(userAgent)}`;
}

export function getStatusLabel(status, context) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "active") return context === "device" ? "Activo" : "Activa";
  if (normalized === "pending") return "Pendiente";
  if (normalized === "revoked") return context === "device" ? "Revocado" : "Revocada";
  if (normalized === "expired") return "Vencida";
  if (normalized === "missing") return "No autorizado";
  if (normalized === "admin_bypass") return "Administrador";
  return "Sin dato";
}

export function getStatusColor(status) {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "active") return "success";
  if (normalized === "pending") return "warning";
  if (normalized === "revoked") return "error";
  if (normalized === "expired") return "default";
  if (normalized === "missing") return "error";
  if (normalized === "admin_bypass") return "info";
  return "default";
}
